import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useClientAuth } from '../context/ClientAuthContext';
import { useLanguage } from '../context/LanguageContext';
import { trackInitiateCheckout } from '../hooks/useAnalytics';

const OPTION_AMOUNT = { solo: 19.90, communaute: 49 };

/* Point d'entrée unique "rejoindre ce pack" utilisé partout sur le site (marketing,
   upsells in-app) : connexion si nécessaire, puis renvoi vers l'onglet "Abonnement" de
   l'app (SubscriptionTab, plan pré-ouvert + paiement auto-déclenché) — c'est le SEUL
   endroit qui appelle Stripe, avec la garantie d'utiliser l'email du compte connecté. */
const CheckoutRedirectPage = () => {
  const { option } = useParams();
  const navigate = useNavigate();
  const { isAuthed, loading } = useClientAuth();
  const { language } = useLanguage();
  const en = language === 'en';
  const L = (fr, eng) => (en ? eng : fr);

  useEffect(() => {
    if (loading) return;
    const dest = `/mon-espace?tab=profil&plan=${option}&autopay=1`;
    if (!isAuthed) {
      trackInitiateCheckout(OPTION_AMOUNT[option] || 0, 'CHF', { option });
      navigate(`/espace-client?next=${encodeURIComponent(dest)}`, { replace: true });
      return;
    }
    navigate(dest, { replace: true });
  }, [loading, isAuthed, option, navigate]);

  return (
    <main className="min-h-screen bg-black flex items-center justify-center px-4" data-testid="checkout-redirect-loading">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto mb-3" />
        <p className="text-zinc-400 text-sm">{L('Redirection…', 'Redirecting…')}</p>
      </div>
    </main>
  );
};

export default CheckoutRedirectPage;
